module.exports = __webpack_public_path__ + "img/crypto-exchange-gold.2a9ed556.svg";